import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=f5cdc4f8&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5cdc4f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5cdc4f8')) {
      api.createRecord('f5cdc4f8', component.options)
    } else {
      api.reload('f5cdc4f8', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=f5cdc4f8&scoped=true&", function () {
      api.rerender('f5cdc4f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2aOg5mz6pGKOg/JS/comp/Accordion.vue"
export default component.exports